import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { TextField } from 'app/components/FormikField/base';
import { DividerStyled, FieldStyled, FormLabelStyled, GridItemStyled } from '../EditEmployerForm.styles';

export const EmployerContactFields = () => {
  const intl = useIntl();
  return (
    <>
      <GridItemStyled item xs={4}>
        <FormLabelStyled>
          <FormattedMessage id="employers.employerEmail" />
        </FormLabelStyled>
        <FieldStyled
          color="secondary"
          component={TextField}
          fullWidth
          name="employerEmail"
          placeholder={intl.formatMessage({ id: 'employers.email' }).toUpperCase()}
          type="email"
          variant="outlined"
        />
      </GridItemStyled>
      <GridItemStyled item xs={4}>
        <FormLabelStyled>
          <FormattedMessage id="employers.employerPhone" />
        </FormLabelStyled>
        <FieldStyled
          color="secondary"
          component={TextField}
          fullWidth
          name="employerPhone"
          placeholder={intl.formatMessage({ id: 'employers.employerPhone' }).toUpperCase()}
          variant="outlined"
        />
      </GridItemStyled>
      <GridItemStyled item xs={4}>
        <FormLabelStyled>
          <FormattedMessage id="employers.internalNumber" />
        </FormLabelStyled>
        <FieldStyled
          color="secondary"
          component={TextField}
          fullWidth
          name="internalNumber"
          placeholder={intl.formatMessage({ id: 'employers.internalNumber' }).toUpperCase()}
          variant="outlined"
        />
      </GridItemStyled>
      <GridItemStyled item xs={4} style={{ display: 'none' }}>
        <FormLabelStyled>
          <FormattedMessage id="employers.numberOfEmployees" />
        </FormLabelStyled>
        <FieldStyled
          sizeSmall
          color="secondary"
          component={TextField}
          disabled
          name="numberOfEmployees"
          placeholder={intl.formatMessage({ id: 'employers.numberOfEmployees' }).toUpperCase()}
          type="number"
          variant="outlined"
        />
      </GridItemStyled>

      <DividerStyled />

      <GridItemStyled item xs={4}>
        <FormLabelStyled>
          <FormattedMessage id="employers.contactName" />
        </FormLabelStyled>
        <FieldStyled
          color="secondary"
          component={TextField}
          fullWidth
          name="contactName"
          placeholder={intl.formatMessage({ id: 'employers.contactName' }).toUpperCase()}
          variant="outlined"
        />
      </GridItemStyled>
      <GridItemStyled item xs={4}>
        <FormLabelStyled>
          <FormattedMessage id="employers.contactEmail" />
        </FormLabelStyled>
        <FieldStyled
          color="secondary"
          component={TextField}
          fullWidth
          name="contactEmail"
          placeholder={intl.formatMessage({ id: 'employers.contactEmail' }).toUpperCase()}
          type="email"
          variant="outlined"
        />
      </GridItemStyled>
      <GridItemStyled item xs={4}>
        <FormLabelStyled>
          <FormattedMessage id="employers.contactPhone" />
        </FormLabelStyled>
        <FieldStyled
          color="secondary"
          component={TextField}
          fullWidth
          name="contactPhone"
          placeholder={intl.formatMessage({ id: 'employers.contactPhone' }).toUpperCase()}
          variant="outlined"
        />
      </GridItemStyled>
    </>
  );
};
